import { IAbUseExperiment } from '../types/abUseExperiments';

export const REQUEST_DEMAND_POSITION = 'new_request_demand_position';

export enum ERequestDemandExperiment {
  A = 'A',
  B = 'B',
  C = 'C',
}

export const getDemandExperiment = (experiments: IAbUseExperiment[]): ERequestDemandExperiment => {
  const experiment = experiments.find(exp => exp.experimentName === REQUEST_DEMAND_POSITION);
  if (!experiment || !experiment.groupName) {
    return ERequestDemandExperiment.A;
  }

  return experiment.groupName as ERequestDemandExperiment;
};
